import { Icon, type IconName } from '@tkww/orion-web-ds-graphic';
import { TextBody } from '@tkww/orion-web-ds-text';
import React from 'react';

import Styles from '../../styles.scss';

interface Props {
	url?: string;
	text: string;
	icon: IconName;
	image?: string;
	name?: string;
}

export const ShareLink = ({
	url,
	text,
	icon,
	image = '',
	name = '',
}: Props) => {
	let shareLink = url;

	if (image) {
		shareLink = `https://pinterest.com/pin/create/button?url=${url}&media=${image}&description=${text}`;
	} else if (text === 'Facebook') {
		shareLink = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
	} else if (text === 'X') {
		shareLink = `https://x.com/intent/post?text=Check%20out%20${encodeURIComponent(name)}&url=${url}&via=theknot`;
	} else if (text === 'Email') {
		shareLink = `mailto:?subject=Check out this vendor on The Knot&body=I thought you might be interested in this vendor on The Knot: ${url}`;
	}

	return (
		<a
			href={shareLink}
			target="_blank"
			rel="noopener noreferrer nofollow"
			className={Styles.shareLink}
			aria-label={text ? `Share via ${text}` : 'Share'}
		>
			<Icon
				name={icon}
				size="md"
				className={Styles.shareLinkImage}
				aria-label={undefined}
				aria-hidden
			/>
			<TextBody size="md">{text}</TextBody>
		</a>
	);
};
